import { Sprout } from "lucide-react";

export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div data-testid="services-marquee" className="overflow-hidden border-y border-white/10 bg-[#163B2C] py-5">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-2xl font-semibold italic tracking-tight text-[#F6F4EE]/90 sm:text-3xl">
              {item}
            </span>
            <Sprout className="h-5 w-5 shrink-0 text-[#22C55E]" />
          </span>
        ))}
      </div>
    </div>
  );
};
